angular.module('pe4h').controller('ViewSmallProposal', function($scope, $http, $q, configuration, Upload, $uibModal) { 
	
	/*$scope.init = function(){

	}
	console.log($scope.myProposal);*/
	
});
